export var ActionEnum;
(function (ActionEnum) {
    ActionEnum["All"] = "ALL";
    ActionEnum["ApicredsAll"] = "APICREDS_ALL";
    ActionEnum["ApicredsCreate"] = "APICREDS_CREATE";
    ActionEnum["ApicredsDeactivate"] = "APICREDS_DEACTIVATE";
    ActionEnum["ApicredsGet"] = "APICREDS_GET";
    ActionEnum["DataAll"] = "DATA_ALL";
    ActionEnum["DataRead"] = "DATA_READ";
    ActionEnum["GroupAddUser"] = "GROUP_ADD_USER";
    ActionEnum["GroupAll"] = "GROUP_ALL";
    ActionEnum["GroupCreate"] = "GROUP_CREATE";
    ActionEnum["GroupDelete"] = "GROUP_DELETE";
    ActionEnum["GroupGet"] = "GROUP_GET";
    ActionEnum["GroupRemoveUser"] = "GROUP_REMOVE_USER";
    ActionEnum["OrgAll"] = "ORG_ALL";
    ActionEnum["OrgGet"] = "ORG_GET";
    ActionEnum["OrgListUsers"] = "ORG_LIST_USERS";
    ActionEnum["RoleAll"] = "ROLE_ALL";
    ActionEnum["RoleAssign"] = "ROLE_ASSIGN";
    ActionEnum["RoleCreate"] = "ROLE_CREATE";
    ActionEnum["RoleDeactivate"] = "ROLE_DEACTIVATE";
    ActionEnum["RoleGet"] = "ROLE_GET";
    ActionEnum["RoleUpdate"] = "ROLE_UPDATE";
    ActionEnum["TableAll"] = "TABLE_ALL";
    ActionEnum["TableRead"] = "TABLE_READ";
    ActionEnum["UniAll"] = "UNI_ALL";
    ActionEnum["UniCreate"] = "UNI_CREATE";
    ActionEnum["UniDelete"] = "UNI_DELETE";
    ActionEnum["UniDeleteNode"] = "UNI_DELETE_NODE";
    ActionEnum["UniEvolveSchema"] = "UNI_EVOLVE_SCHEMA";
    ActionEnum["UniGet"] = "UNI_GET";
    ActionEnum["UniInvite"] = "UNI_INVITE";
    ActionEnum["UniJoin"] = "UNI_JOIN";
    ActionEnum["UniMutate"] = "UNI_MUTATE";
    ActionEnum["UniQuery"] = "UNI_QUERY";
    ActionEnum["UniReset"] = "UNI_RESET";
    ActionEnum["UserAll"] = "USER_ALL";
    ActionEnum["UserCreate"] = "USER_CREATE";
    ActionEnum["UserDeactivate"] = "USER_DEACTIVATE";
    ActionEnum["UserDelegateNodeJoin"] = "USER_DELEGATE_NODE_JOIN";
    ActionEnum["UserDelete"] = "USER_DELETE";
    ActionEnum["UserDeleteRole"] = "USER_DELETE_ROLE";
    ActionEnum["UserGet"] = "USER_GET";
    ActionEnum["UserInvite"] = "USER_INVITE";
    ActionEnum["UserSetEmail"] = "USER_SET_EMAIL";
    ActionEnum["UserSetRole"] = "USER_SET_ROLE";
    ActionEnum["WorkflowsAll"] = "WORKFLOWS_ALL";
    ActionEnum["WorkflowsGet"] = "WORKFLOWS_GET";
    ActionEnum["WorkflowsUpdate"] = "WORKFLOWS_UPDATE";
})(ActionEnum || (ActionEnum = {}));
export var ApiCatalogAuthType;
(function (ApiCatalogAuthType) {
    ApiCatalogAuthType["Apikey"] = "apikey";
    ApiCatalogAuthType["None"] = "none";
})(ApiCatalogAuthType || (ApiCatalogAuthType = {}));
export var AuthorizerType;
(function (AuthorizerType) {
    AuthorizerType["Authv2"] = "AUTHV2";
})(AuthorizerType || (AuthorizerType = {}));
export var CspEnum;
(function (CspEnum) {
    CspEnum["Alicloud"] = "ALICLOUD";
    CspEnum["Aws"] = "AWS";
    CspEnum["Azure"] = "AZURE";
    CspEnum["Gcp"] = "GCP";
    CspEnum["Ibm"] = "IBM";
    CspEnum["Oracle"] = "ORACLE";
    CspEnum["Tencent"] = "TENCENT";
})(CspEnum || (CspEnum = {}));
export var CspLowerEnum;
(function (CspLowerEnum) {
    CspLowerEnum["Aws"] = "aws";
    CspLowerEnum["Azure"] = "azure";
})(CspLowerEnum || (CspLowerEnum = {}));
export var DataCustodyEnum;
(function (DataCustodyEnum) {
    DataCustodyEnum["Retain"] = "RETAIN";
})(DataCustodyEnum || (DataCustodyEnum = {}));
export var DataPolicyColumnEffect;
(function (DataPolicyColumnEffect) {
    DataPolicyColumnEffect["Allow"] = "ALLOW";
    DataPolicyColumnEffect["Exclude"] = "EXCLUDE";
    DataPolicyColumnEffect["Mask"] = "MASK";
    DataPolicyColumnEffect["MaskExceptLast"] = "MASK_EXCEPT_LAST";
    DataPolicyColumnEffect["Replace"] = "REPLACE";
})(DataPolicyColumnEffect || (DataPolicyColumnEffect = {}));
export var DataPolicyOperator;
(function (DataPolicyOperator) {
    DataPolicyOperator["Equals"] = "EQUALS";
    DataPolicyOperator["GreaterThan"] = "GREATER_THAN";
    DataPolicyOperator["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
    DataPolicyOperator["In"] = "IN";
    DataPolicyOperator["IsNotNull"] = "IS_NOT_NULL";
    DataPolicyOperator["IsNull"] = "IS_NULL";
    DataPolicyOperator["LessThan"] = "LESS_THAN";
    DataPolicyOperator["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
    DataPolicyOperator["Like"] = "LIKE";
    DataPolicyOperator["NotEquals"] = "NOT_EQUALS";
    DataPolicyOperator["NotIn"] = "NOT_IN";
    DataPolicyOperator["NotLike"] = "NOT_LIKE";
})(DataPolicyOperator || (DataPolicyOperator = {}));
export var DataPolicyRowEffect;
(function (DataPolicyRowEffect) {
    DataPolicyRowEffect["Allow"] = "ALLOW";
    DataPolicyRowEffect["Exclude"] = "EXCLUDE";
})(DataPolicyRowEffect || (DataPolicyRowEffect = {}));
export var DistributionAccessRecipientType;
(function (DistributionAccessRecipientType) {
    DistributionAccessRecipientType["Email"] = "EMAIL";
})(DistributionAccessRecipientType || (DistributionAccessRecipientType = {}));
export var DistributionFormat;
(function (DistributionFormat) {
    DistributionFormat["Csv"] = "CSV";
    DistributionFormat["Deltalake"] = "DELTALAKE";
    DistributionFormat["Iceberg"] = "ICEBERG";
})(DistributionFormat || (DistributionFormat = {}));
export var DistributionRunStatus;
(function (DistributionRunStatus) {
    DistributionRunStatus["Cancelled"] = "CANCELLED";
    DistributionRunStatus["Failed"] = "FAILED";
    DistributionRunStatus["Provisioning"] = "PROVISIONING";
    DistributionRunStatus["Running"] = "RUNNING";
    DistributionRunStatus["Succeeded"] = "SUCCEEDED";
})(DistributionRunStatus || (DistributionRunStatus = {}));
export var DistributionTargetType;
(function (DistributionTargetType) {
    DistributionTargetType["S3Bucket"] = "S3BUCKET";
})(DistributionTargetType || (DistributionTargetType = {}));
export var EvolutionMode;
(function (EvolutionMode) {
    EvolutionMode["Fast"] = "FAST";
    EvolutionMode["FullUpdate"] = "FULL_UPDATE";
    EvolutionMode["ZeroDowntime"] = "ZERO_DOWNTIME";
})(EvolutionMode || (EvolutionMode = {}));
export var EvolveSchemaBreakingChangesEnum;
(function (EvolveSchemaBreakingChangesEnum) {
    EvolveSchemaBreakingChangesEnum["IndexRemoved"] = "INDEX_REMOVED";
})(EvolveSchemaBreakingChangesEnum || (EvolveSchemaBreakingChangesEnum = {}));
export var GatewayConnectionStatus;
(function (GatewayConnectionStatus) {
    GatewayConnectionStatus["Connected"] = "CONNECTED";
    GatewayConnectionStatus["NotConnected"] = "NOT_CONNECTED";
    GatewayConnectionStatus["ReAuthRequired"] = "RE_AUTH_REQUIRED";
    GatewayConnectionStatus["Unknown"] = "UNKNOWN";
})(GatewayConnectionStatus || (GatewayConnectionStatus = {}));
export var GatewayServerAuthType;
(function (GatewayServerAuthType) {
    GatewayServerAuthType["None"] = "NONE";
    GatewayServerAuthType["OauthDcr"] = "OAUTH_DCR";
    GatewayServerAuthType["OauthStatic"] = "OAUTH_STATIC";
})(GatewayServerAuthType || (GatewayServerAuthType = {}));
export var IntentTypeEnum;
(function (IntentTypeEnum) {
    IntentTypeEnum["PaymentIntent"] = "paymentIntent";
    IntentTypeEnum["SetupIntent"] = "setupIntent";
})(IntentTypeEnum || (IntentTypeEnum = {}));
export var LakehouseConnectionTypeEnum;
(function (LakehouseConnectionTypeEnum) {
    LakehouseConnectionTypeEnum["Bigquery"] = "BIGQUERY";
    LakehouseConnectionTypeEnum["Cloudera"] = "CLOUDERA";
    LakehouseConnectionTypeEnum["Databricks"] = "DATABRICKS";
    LakehouseConnectionTypeEnum["Mysql"] = "MYSQL";
    LakehouseConnectionTypeEnum["Postgres"] = "POSTGRES";
    LakehouseConnectionTypeEnum["S3"] = "S3";
    LakehouseConnectionTypeEnum["Snowflake"] = "SNOWFLAKE";
    LakehouseConnectionTypeEnum["Upload"] = "UPLOAD";
    LakehouseConnectionTypeEnum["Vendia"] = "VENDIA";
})(LakehouseConnectionTypeEnum || (LakehouseConnectionTypeEnum = {}));
export var LakehouseSyncScheduleEnum;
(function (LakehouseSyncScheduleEnum) {
    LakehouseSyncScheduleEnum["Daily"] = "DAILY";
    LakehouseSyncScheduleEnum["Monthly"] = "MONTHLY";
    LakehouseSyncScheduleEnum["OnDemand"] = "ON_DEMAND";
    LakehouseSyncScheduleEnum["Weekly"] = "WEEKLY";
})(LakehouseSyncScheduleEnum || (LakehouseSyncScheduleEnum = {}));
export var LakehouseTableAclOperationEnum;
(function (LakehouseTableAclOperationEnum) {
    LakehouseTableAclOperationEnum["All"] = "ALL";
    LakehouseTableAclOperationEnum["Read"] = "READ";
})(LakehouseTableAclOperationEnum || (LakehouseTableAclOperationEnum = {}));
export var LakehouseTableStatusEnum;
(function (LakehouseTableStatusEnum) {
    LakehouseTableStatusEnum["Creating"] = "CREATING";
    LakehouseTableStatusEnum["Deleted"] = "DELETED";
    LakehouseTableStatusEnum["Error"] = "ERROR";
    LakehouseTableStatusEnum["Ready"] = "READY";
    LakehouseTableStatusEnum["Updating"] = "UPDATING";
})(LakehouseTableStatusEnum || (LakehouseTableStatusEnum = {}));
export var MySqlSslMode;
(function (MySqlSslMode) {
    MySqlSslMode["Disable"] = "DISABLE";
    MySqlSslMode["Prefer"] = "PREFER";
    MySqlSslMode["Require"] = "REQUIRE";
    MySqlSslMode["VerifyCa"] = "VERIFY_CA";
    MySqlSslMode["VerifyIdentity"] = "VERIFY_IDENTITY";
})(MySqlSslMode || (MySqlSslMode = {}));
export var NodeAccessLevel;
(function (NodeAccessLevel) {
    NodeAccessLevel["All"] = "ALL";
})(NodeAccessLevel || (NodeAccessLevel = {}));
export var NodeLeaveEnum;
(function (NodeLeaveEnum) {
    NodeLeaveEnum["Archive"] = "ARCHIVE";
    NodeLeaveEnum["Destroy"] = "DESTROY";
})(NodeLeaveEnum || (NodeLeaveEnum = {}));
export var OperationEnum;
(function (OperationEnum) {
    OperationEnum["Eq"] = "EQ";
})(OperationEnum || (OperationEnum = {}));
export var OrgOnboardingStatus;
(function (OrgOnboardingStatus) {
    OrgOnboardingStatus["CreateOrgCompleted"] = "CREATE_ORG_COMPLETED";
    OrgOnboardingStatus["CreateOrgRequested"] = "CREATE_ORG_REQUESTED";
    OrgOnboardingStatus["Ineligible"] = "INELIGIBLE";
    OrgOnboardingStatus["OnboardingNotCompleted"] = "ONBOARDING_NOT_COMPLETED";
    OrgOnboardingStatus["OnboardingNotNotified"] = "ONBOARDING_NOT_NOTIFIED";
})(OrgOnboardingStatus || (OrgOnboardingStatus = {}));
export var PostgresSslMode;
(function (PostgresSslMode) {
    PostgresSslMode["Allow"] = "ALLOW";
    PostgresSslMode["Disable"] = "DISABLE";
    PostgresSslMode["Prefer"] = "PREFER";
    PostgresSslMode["Require"] = "REQUIRE";
    PostgresSslMode["VerifyCa"] = "VERIFY_CA";
    PostgresSslMode["VerifyFull"] = "VERIFY_FULL";
})(PostgresSslMode || (PostgresSslMode = {}));
export var ProductTierSku;
(function (ProductTierSku) {
    ProductTierSku["Enterprise"] = "ENTERPRISE";
    ProductTierSku["Individual"] = "INDIVIDUAL";
    ProductTierSku["Pro"] = "PRO";
})(ProductTierSku || (ProductTierSku = {}));
export var SnowflakeAuthType;
(function (SnowflakeAuthType) {
    SnowflakeAuthType["Oauth"] = "OAUTH";
    SnowflakeAuthType["Password"] = "PASSWORD";
})(SnowflakeAuthType || (SnowflakeAuthType = {}));
export var StatusEnum;
(function (StatusEnum) {
    StatusEnum["Adding"] = "ADDING";
    StatusEnum["Archived"] = "ARCHIVED";
    StatusEnum["Backfilling"] = "BACKFILLING";
    StatusEnum["Deploying"] = "DEPLOYING";
    StatusEnum["Destroyed"] = "DESTROYED";
    StatusEnum["Destroying"] = "DESTROYING";
    StatusEnum["Error"] = "ERROR";
    StatusEnum["Evolved"] = "EVOLVED";
    StatusEnum["Evolving"] = "EVOLVING";
    StatusEnum["PendingRegistration"] = "PENDING_REGISTRATION";
    StatusEnum["Running"] = "RUNNING";
    StatusEnum["Servicing"] = "SERVICING";
    StatusEnum["Stopped"] = "STOPPED";
    StatusEnum["StopRequested"] = "STOP_REQUESTED";
    StatusEnum["Unknown"] = "UNKNOWN";
    StatusEnum["Updating"] = "UPDATING";
})(StatusEnum || (StatusEnum = {}));
export var StorageConnectionTypeEnum;
(function (StorageConnectionTypeEnum) {
    StorageConnectionTypeEnum["S3"] = "S3";
})(StorageConnectionTypeEnum || (StorageConnectionTypeEnum = {}));
export var UniSkuEnum;
(function (UniSkuEnum) {
    UniSkuEnum["Lakehouse"] = "LAKEHOUSE";
    UniSkuEnum["Share"] = "SHARE";
    UniSkuEnum["ShareFinancialServices"] = "SHARE_FINANCIAL_SERVICES";
    UniSkuEnum["Vdl"] = "VDL";
})(UniSkuEnum || (UniSkuEnum = {}));
export var UniSkuTierEnum;
(function (UniSkuTierEnum) {
    UniSkuTierEnum["Enterprise"] = "ENTERPRISE";
    UniSkuTierEnum["EnterpriseTrial"] = "ENTERPRISE_TRIAL";
    UniSkuTierEnum["Free"] = "FREE";
    UniSkuTierEnum["Individual"] = "INDIVIDUAL";
    UniSkuTierEnum["IndividualTrial"] = "INDIVIDUAL_TRIAL";
})(UniSkuTierEnum || (UniSkuTierEnum = {}));
export var UniStatsAggregationUnitEnum;
(function (UniStatsAggregationUnitEnum) {
    UniStatsAggregationUnitEnum["Day"] = "DAY";
    UniStatsAggregationUnitEnum["Hour"] = "HOUR";
})(UniStatsAggregationUnitEnum || (UniStatsAggregationUnitEnum = {}));
export class TypedDocumentString extends String {
    __apiType;
    value;
    __meta__;
    constructor(value, __meta__) {
        super(value);
        this.value = value;
        this.__meta__ = __meta__;
    }
    toString() {
        return this.value;
    }
}
export const CreateApiCatalogDocument = new TypedDocumentString(`
    mutation CreateApiCatalog($input: CreateApiCatalogInput!, $asRole: String) {
  createApiCatalog(input: $input, asRole: $asRole) {
    success
    apiCatalogId
    message
  }
}
    `);
export const UpdateApiCatalogDocument = new TypedDocumentString(`
    mutation UpdateApiCatalog($input: UpdateApiCatalogInput!, $asRole: String) {
  updateApiCatalog(input: $input, asRole: $asRole) {
    success
    message
  }
}
    `);
export const DeleteApiCatalogDocument = new TypedDocumentString(`
    mutation DeleteApiCatalog($uniName: String!, $nodeName: String!, $catalogId: String!, $asRole: String) {
  deleteApiCatalog(
    uniName: $uniName
    nodeName: $nodeName
    catalogId: $catalogId
    asRole: $asRole
  )
}
    `);
export const GetApiCatalogHeadersDocument = new TypedDocumentString(`
    query GetApiCatalogHeaders($uniName: String!, $nodeName: String!, $catalogId: String!, $asRole: String) {
  getApiCatalogHeaders(
    uniName: $uniName
    nodeName: $nodeName
    catalogId: $catalogId
    asRole: $asRole
  ) {
    headers {
      key
      value
    }
    accessPolicyHeaders {
      policyId
      headers {
        key
        value
      }
    }
  }
}
    `);
export const FetchApiCatalogSpecDocument = new TypedDocumentString(`
    query FetchApiCatalogSpec($input: FetchApiCatalogSpecInput!, $asRole: String) {
  fetchApiCatalogSpec(input: $input, asRole: $asRole) {
    content
    isTruncated
    contentType
    actualSize
  }
}
    `);
export const CreateApiConnectionPolicyDocument = new TypedDocumentString(`
    mutation CreateApiConnectionPolicy($input: CreateApiConnectionPolicyInput!, $asRole: String) {
  createApiConnectionPolicy(input: $input, asRole: $asRole) {
    policyId
  }
}
    `);
export const UpdateApiConnectionPolicyDocument = new TypedDocumentString(`
    mutation UpdateApiConnectionPolicy($input: UpdateApiConnectionPolicyInput!, $asRole: String) {
  updateApiConnectionPolicy(input: $input, asRole: $asRole) {
    success
  }
}
    `);
export const DeleteApiConnectionPolicyDocument = new TypedDocumentString(`
    mutation DeleteApiConnectionPolicy($input: DeleteApiConnectionPolicyInput!, $asRole: String) {
  deleteApiConnectionPolicy(input: $input, asRole: $asRole) {
    success
  }
}
    `);
export const CreateApiCredentialsDocument = new TypedDocumentString(`
    mutation CreateApiCredentials($name: String!, $roleId: String!, $expiresAt: String, $asRole: String) {
  createApiCredentials(
    apiCredentials: {name: $name, roleId: $roleId, expiresAt: $expiresAt}
    asRole: $asRole
  ) {
    apiCredentialsId
    clientSecret
  }
}
    `);
export const DeactivateApiCredentialsDocument = new TypedDocumentString(`
    mutation DeactivateApiCredentials($apiCredentialsId: String!, $asRole: String) {
  deactivateApiCredentials(apiCredentialsId: $apiCredentialsId, asRole: $asRole)
}
    `);
export const SyncDistributionDocument = new TypedDocumentString(`
    mutation SyncDistribution($uniName: String!, $nodeName: String!, $distributionId: String!, $asRole: String) {
  syncDistribution(
    uniName: $uniName
    nodeName: $nodeName
    distributionId: $distributionId
    asRole: $asRole
  ) {
    distributionId
    result
    details
  }
}
    `);
export const SyncTableToDistributionDocument = new TypedDocumentString(`
    mutation SyncTableToDistribution($uniName: String!, $nodeName: String!, $distributionName: String!, $distributionId: String!, $tableName: String!, $asRole: String) {
  syncTableToDistribution(
    uniName: $uniName
    nodeName: $nodeName
    distributionName: $distributionName
    distributionId: $distributionId
    tableName: $tableName
    asRole: $asRole
  ) {
    distributionId
    tableName
    taskCount
    result
    details
  }
}
    `);
export const OfferDistributionAccessDocument = new TypedDocumentString(`
    mutation OfferDistributionAccess($uniName: String!, $distributionName: String!, $distributionId: String, $offeredEmail: String!, $nodeName: String!, $asRole: String) {
  offerDistributionAccess(
    input: {uniName: $uniName, distributionName: $distributionName, distributionId: $distributionId, offeredEmail: $offeredEmail, nodeName: $nodeName}
    asRole: $asRole
  ) {
    message
    id
    temporaryToken
  }
}
    `);
export const AddDistributionDocument = new TypedDocumentString(`
    mutation AddDistribution($name: String!, $description: String, $target: DistributionTargetInput!, $tables: [DistributionTableInput!]!, $uniName: String!, $nodeName: String!, $asRole: String) {
  addDistribution(
    name: $name
    description: $description
    target: $target
    tables: $tables
    uniName: $uniName
    nodeName: $nodeName
    asRole: $asRole
  ) {
    id
    name
  }
}
    `);
export const DeleteDistributionDocument = new TypedDocumentString(`
    mutation DeleteDistribution($distributionId: String!, $uniName: String!, $nodeName: String!, $asRole: String) {
  deleteDistribution(
    distributionId: $distributionId
    uniName: $uniName
    nodeName: $nodeName
    asRole: $asRole
  )
}
    `);
export const AddDistributionAccessGrantDocument = new TypedDocumentString(`
    mutation AddDistributionAccessGrant($token: String!, $externalAccessRole: String!, $externalIds: [String!]!, $name: String, $asRole: String) {
  addDistributionAccessGrant(
    input: {token: $token, externalAccessRole: $externalAccessRole, externalIds: $externalIds, name: $name}
    asRole: $asRole
  ) {
    message
    buildId
  }
}
    `);
export const ListDistributionsDocument = new TypedDocumentString(`
    query ListDistributions($asRole: String) {
  listDistributions(asRole: $asRole) {
    distributions {
      name
      orgName
      orgLogo
      distroAccessId
      accessGrants {
        name
        customerExternalRoleArn
        customerExternalIds
      }
      tableCount
    }
    nextToken
  }
}
    `);
export const GetDistributionDetailsDocument = new TypedDocumentString(`
    query GetDistributionDetails($distroAccessId: String!, $asRole: String) {
  getDistributionDetails(distroAccessId: $distroAccessId, asRole: $asRole) {
    name
    description
    orgName
    orgLogo
    distroAccessId
    accessGrants {
      name
      customerExternalRoleArn
      customerExternalIds
    }
    tableCount
    tables {
      name
      rowCount
      totalDataSize
      lastUpdated
      tableSchema {
        name
        type
      }
    }
    productKey
    awsRoleArn
    awsS3LocationIceberg
    awsS3LocationDelta
  }
}
    `);
export const GetDistributionAccessDetailsDocument = new TypedDocumentString(`
    query GetDistributionAccessDetails($distributionId: String!, $uniName: String!, $nodeName: String!, $asRole: String) {
  getDistributionAccessDetails(
    distributionId: $distributionId
    uniName: $uniName
    nodeName: $nodeName
    asRole: $asRole
  ) {
    id
    recipient
    recipientType
    distributionRoleArn
    accessGrants {
      customerExternalRoleArn
      customerExternalIds
    }
    createdAt
    lastUpdatedAt
  }
}
    `);
export const GetDistributionStatusDocument = new TypedDocumentString(`
    query GetDistributionStatus($uniName: String!, $nodeName: String!, $distributionId: String!, $asRole: String) {
  getDistributionStatus(
    uniName: $uniName
    nodeName: $nodeName
    distributionId: $distributionId
    asRole: $asRole
  ) {
    status
    message
    updatedAt
    syncedToLatest
  }
}
    `);
export const GetDistributionTableStatusDocument = new TypedDocumentString(`
    query GetDistributionTableStatus($uniName: String!, $nodeName: String!, $tableName: String!, $distributionId: String!, $asRole: String) {
  getDistributionTableStatus(
    uniName: $uniName
    nodeName: $nodeName
    tableName: $tableName
    distributionId: $distributionId
    asRole: $asRole
  ) {
    status
    message
    updatedAt
    syncedToLatest
  }
}
    `);
export const GetDistributionTableDetailsDocument = new TypedDocumentString(`
    query GetDistributionTableDetails($uniName: String!, $nodeName: String!, $distributionId: String!, $tableName: String!, $asRole: String) {
  getDistributionTableDetails(
    uniName: $uniName
    nodeName: $nodeName
    distributionId: $distributionId
    tableName: $tableName
    asRole: $asRole
  ) {
    rowCount
    totalDataSize
    lastUpdated
    tableSchema {
      name
      type
    }
  }
}
    `);
export const GetVendiaTableDetailsDocument = new TypedDocumentString(`
    query GetVendiaTableDetails($uniName: String!, $nodeName: String!, $tableKey: String!) {
  getVendiaTableDetails(
    uniName: $uniName
    nodeName: $nodeName
    tableKey: $tableKey
  ) {
    rowCount
    totalDataSize
    lastUpdated
    tableSchema {
      name
      type
    }
  }
}
    `);
export const GetEmbeddedAppDocument = new TypedDocumentString(`
    query GetEmbeddedApp($externalId: String!, $asRole: String) {
  getEmbeddedApp(externalId: $externalId, asRole: $asRole) {
    applicationId
    applicationType
    dataMapping
    externalId
    orgId
    uniName
    nodeName
    lastUpdated
    lastUpdatedBy
  }
}
    `);
export const UpdateEmbeddedAppDocument = new TypedDocumentString(`
    mutation UpdateEmbeddedApp($input: UpdateEmbeddedAppInput!, $asRole: String) {
  updateEmbeddedApp(input: $input, asRole: $asRole) {
    applicationId
    lastUpdated
    lastUpdatedBy
  }
}
    `);
export const InitializeEmbeddedAppDocument = new TypedDocumentString(`
    mutation InitializeEmbeddedApp($input: InitializeEmbeddedAppInput!, $asRole: String) {
  initializeEmbeddedApp(input: $input, asRole: $asRole) {
    connections {
      id
    }
  }
}
    `);
export const PrepareEmbeddedAppObjectSchemaDocument = new TypedDocumentString(`
    mutation PrepareEmbeddedAppObjectSchema($input: PrepareEmbeddedAppObjectSchemaInput!, $asRole: String) {
  prepareEmbeddedAppObjectSchema(input: $input, asRole: $asRole) {
    status {
      success
    }
    id
  }
}
    `);
export const CompleteEmbeddedAppSetupDocument = new TypedDocumentString(`
    mutation CompleteEmbeddedAppSetup($input: CompleteEmbeddedAppSetupInput!, $asRole: String) {
  completeEmbeddedAppSetup(input: $input, asRole: $asRole) {
    applicationId
    applicationType
    externalId
    orgId
    uniName
    nodeName
    lastUpdated
    lastUpdatedBy
  }
}
    `);
export const ListS3FilesDocument = new TypedDocumentString(`
    query ListS3Files($input: ListS3FilesInput!) {
  listS3Files(input: $input) {
    objects {
      key
      size
      lastModified
    }
    isTruncated
    nextToken
  }
}
    `);
export const FetchFilePreviewDocument = new TypedDocumentString(`
    query FetchFilePreview($input: FetchFilePreviewInput!) {
  fetchFilePreview(input: $input) {
    content
    isTruncated
    contentType
    actualSize
  }
}
    `);
export const ListGatewayServersDocument = new TypedDocumentString(`
    query ListGatewayServers($uniName: String!, $nodeName: String!) {
  listGatewayServers(uniName: $uniName, nodeName: $nodeName) {
    gatewayServers {
      id
      name
      description
      mcpUrl
      authType
      clientId
      authorizationEndpoint
      tokenEndpoint
      scopes
      connectionStatus
      enabledTools
      headers {
        key
        value
      }
    }
  }
}
    `);
export const AddGatewayServerDocument = new TypedDocumentString(`
    mutation AddGatewayServer($uniName: String!, $nodeName: String!, $gatewayServer: GatewayServerInput!, $asRole: String) {
  addGatewayServer(
    uniName: $uniName
    nodeName: $nodeName
    gatewayServer: $gatewayServer
    asRole: $asRole
  )
}
    `);
export const UpdateGatewayServerDocument = new TypedDocumentString(`
    mutation UpdateGatewayServer($uniName: String!, $nodeName: String!, $_id: String!, $gatewayServer: GatewayServerInput!, $asRole: String) {
  updateGatewayServer(
    uniName: $uniName
    nodeName: $nodeName
    _id: $_id
    gatewayServer: $gatewayServer
    asRole: $asRole
  )
}
    `);
export const DeleteGatewayServerDocument = new TypedDocumentString(`
    mutation DeleteGatewayServer($uniName: String!, $nodeName: String!, $_id: String!) {
  deleteGatewayServer(uniName: $uniName, nodeName: $nodeName, _id: $_id)
}
    `);
export const InitiateGatewayOAuthDocument = new TypedDocumentString(`
    mutation InitiateGatewayOAuth($uniName: String!, $nodeName: String!, $_id: String!, $asRole: String) {
  initiateGatewayOAuth(
    uniName: $uniName
    nodeName: $nodeName
    _id: $_id
    asRole: $asRole
  ) {
    authorizationUrl
  }
}
    `);
export const ListGatewayServerToolsDocument = new TypedDocumentString(`
    query ListGatewayServerTools($uniName: String!, $nodeName: String!, $gatewayServerId: String!, $asRole: String) {
  listGatewayServerTools(
    uniName: $uniName
    nodeName: $nodeName
    gatewayServerId: $gatewayServerId
    asRole: $asRole
  ) {
    connectionStatus
    tools {
      name
      description
      inputSchema
    }
  }
}
    `);
export const DiscoverMcpOAuthMetadataDocument = new TypedDocumentString(`
    query DiscoverMcpOAuthMetadata($mcpUrl: String!) {
  discoverMcpOAuthMetadata(mcpUrl: $mcpUrl) {
    metadata {
      issuer
      authorizationEndpoint
      tokenEndpoint
      registrationEndpoint
      revocationEndpoint
      responseTypesSupported
      grantTypesSupported
      tokenEndpointAuthMethodsSupported
      codeChallengeMethodsSupported
      scopesSupported
    }
  }
}
    `);
export const GetLakehouseTablesDocument = new TypedDocumentString(`
    query GetLakehouseTables($connectionInput: LakehouseConnectionInput!, $uniName: String!, $nodeName: String!, $asRole: String) {
  getLakehouseTables(
    connectionInput: $connectionInput
    uniName: $uniName
    nodeName: $nodeName
    asRole: $asRole
  ) {
    tables
    region
  }
}
    `);
export const GetLakehouseTableSchemaDocument = new TypedDocumentString(`
    query GetLakehouseTableSchema($snowflakeConnection: LakehouseSnowflakeConnectionInput, $clouderaConnection: LakehouseClouderaConnectionInput, $mysqlConnection: LakehouseMySqlConnectionInput, $postgresConnection: LakehousePostgresConnectionInput, $bigqueryConnection: LakehouseBigQueryConnectionInput, $databricksConnection: LakehouseDatabricksConnectionInput, $connectionId: String, $tableName: String!, $asRole: String, $uniName: String!, $nodeName: String!) {
  getLakehouseTableSchema(
    snowflakeConnection: $snowflakeConnection
    clouderaConnection: $clouderaConnection
    mysqlConnection: $mysqlConnection
    postgresConnection: $postgresConnection
    bigqueryConnection: $bigqueryConnection
    databricksConnection: $databricksConnection
    connectionId: $connectionId
    tableName: $tableName
    asRole: $asRole
    uniName: $uniName
    nodeName: $nodeName
  ) {
    name
    nullable
    primaryKey
    uniqueKey
    comment
    type
  }
}
    `);
export const HandleLakehouseOauthDocument = new TypedDocumentString(`
    query HandleLakehouseOauth($connectionInput: LakehouseConnectionInput!, $uniName: String!, $nodeName: String!, $asRole: String) {
  handleLakehouseOauth(
    connectionInput: $connectionInput
    uniName: $uniName
    nodeName: $nodeName
    asRole: $asRole
  ) {
    accessToken
    accessTokenExpiry
    refreshToken
    refreshTokenExpiry
  }
}
    `);
export const FetchLakehouseDataDocument = new TypedDocumentString(`
    query FetchLakehouseData($uniName: String!, $nodeName: String!, $sqlText: String!, $enableCache: Boolean, $asRole: String) {
  fetchLakehouseData(
    uniName: $uniName
    nodeName: $nodeName
    sqlText: $sqlText
    enableCache: $enableCache
    asRole: $asRole
  ) {
    results
  }
}
    `);
export const FetchLakehouseDataPreviewDocument = new TypedDocumentString(`
    query FetchLakehouseDataPreview($uniName: String!, $nodeName: String!, $connectionId: String, $snowflakeConnection: LakehouseSnowflakeConnectionInput, $clouderaConnection: LakehouseClouderaConnectionInput, $mysqlConnection: LakehouseMySqlConnectionInput, $postgresConnection: LakehousePostgresConnectionInput, $bigqueryConnection: LakehouseBigQueryConnectionInput, $databricksConnection: LakehouseDatabricksConnectionInput, $sourceTableDefinition: SourceTableDefinitionInput, $tableDefinition: TableDefinitionInput, $joinQuery: String, $joinTableKey: String, $enableCache: Boolean, $asRole: String) {
  fetchLakehouseDataPreview(
    uniName: $uniName
    nodeName: $nodeName
    connectionId: $connectionId
    snowflakeConnection: $snowflakeConnection
    clouderaConnection: $clouderaConnection
    mysqlConnection: $mysqlConnection
    postgresConnection: $postgresConnection
    bigqueryConnection: $bigqueryConnection
    databricksConnection: $databricksConnection
    sourceTableDefinition: $sourceTableDefinition
    tableDefinition: $tableDefinition
    joinQuery: $joinQuery
    joinTableKey: $joinTableKey
    enableCache: $enableCache
    asRole: $asRole
  )
}
    `);
export const UpdateLakehouseScheduleDocument = new TypedDocumentString(`
    mutation UpdateLakehouseSchedule($uniName: String!, $nodeName: String!, $tableKey: String!, $syncSchedule: LakehouseSyncScheduleEnum!, $asRole: String) {
  updateLakehouseSchedule(
    uniName: $uniName
    nodeName: $nodeName
    tableKey: $tableKey
    syncSchedule: $syncSchedule
    asRole: $asRole
  )
}
    `);
export const InvokeLakehouseIngestionSfnDocument = new TypedDocumentString(`
    mutation InvokeLakehouseIngestionSFN($uniName: String!, $nodeName: String!, $tableKey: String!, $asRole: String) {
  invokeLakehouseIngestionSFN(
    uniName: $uniName
    nodeName: $nodeName
    tableKey: $tableKey
    asRole: $asRole
  )
}
    `);
export const UpdateLakehouseConnectionDocument = new TypedDocumentString(`
    mutation UpdateLakehouseConnection($uniName: String!, $nodeName: String!, $username: String, $password: String, $oauth: SnowflakeOAuthCredentialsInput, $bigquery: LakehouseBigQueryConnectionUpdateInput, $connectionName: String, $connectionId: String!, $asRole: String) {
  updateLakehouseConnection(
    uniName: $uniName
    nodeName: $nodeName
    username: $username
    password: $password
    oauth: $oauth
    bigquery: $bigquery
    connectionName: $connectionName
    connectionId: $connectionId
    asRole: $asRole
  )
}
    `);
export const AddLakehouseTableDocument = new TypedDocumentString(`
    mutation AddLakehouseTable($input: AddLakehouseTableInput!) {
  addLakehouseTable(input: $input)
}
    `);
export const UpdateLakehouseTableDocument = new TypedDocumentString(`
    mutation UpdateLakehouseTable($input: AddLakehouseTableInput!) {
  updateLakehouseTable(input: $input)
}
    `);
export const AddLakehouseConnectionDocument = new TypedDocumentString(`
    mutation AddLakehouseConnection($input: AddLakehouseConnectionInput!) {
  addLakehouseConnection(input: $input)
}
    `);
export const GetLakehouseConnectionDocument = new TypedDocumentString(`
    query GetLakehouseConnection($input: GetLakehouseConnectionInput!) {
  getLakehouseConnection(input: $input)
}
    `);
export const ListLakehouseConnectionsDocument = new TypedDocumentString(`
    query ListLakehouseConnections($input: ListLakehouseConnectionsInput!) {
  listLakehouseConnections(input: $input)
}
    `);
export const DeleteLakehouseConnectionDocument = new TypedDocumentString(`
    mutation DeleteLakehouseConnection($input: DeleteLakehouseConnectionInput!) {
  deleteLakehouseConnection(input: $input)
}
    `);
export const DeleteLakehouseTableDocument = new TypedDocumentString(`
    mutation DeleteLakehouseTable($input: DeleteLakehouseTableInput!) {
  deleteLakehouseTable(input: $input)
}
    `);
export const RegisterMarketplaceUserDocument = new TypedDocumentString(`
    mutation RegisterMarketplaceUser($registrationToken: String!) {
  registerMarketplaceUser(registrationToken: $registrationToken) {
    message
  }
}
    `);
export const CancelIndividualSubscriptionDocument = new TypedDocumentString(`
    mutation CancelIndividualSubscription($sku: UniSkuEnum!) {
  cancelIndividualSubscription(sku: $sku) {
    message
  }
}
    `);
export const GetPaymentPortalUrlDocument = new TypedDocumentString(`
    query GetPaymentPortalUrl {
  getPaymentPortalUrl
}
    `);
export const InitializeIndividualSubscriptionDocument = new TypedDocumentString(`
    mutation InitializeIndividualSubscription {
  initializeIndividualSubscription(sku: SHARE) {
    message
    clientSecret
    customerId
    subscriptionId
  }
}
    `);
export const ProvisionIndividualUniDocument = new TypedDocumentString(`
    mutation ProvisionIndividualUni($asRole: String) {
  provisionIndividualUni(asRole: $asRole) {
    message
  }
}
    `);
export const OrgDocument = new TypedDocumentString(`
    query Org($asRole: String) {
  getOrganization(asRole: $asRole) {
    orgId
    name
    logo
    domains
    onboardingStatus
    defaultRole {
      roleId
      name
      capabilities {
        action
        resources
        conditions
      }
    }
    subscription {
      product
      tier
      status
      expiry
    }
    productTier {
      sku
      name
      description
      featureFlags
      limits {
        mcpS3Connections
        mcpApiCatalogs
        mcpServers
        mcpUserRequestsPerHour
        mcpWorkspaceRequestsPerHour
        mcpApiCredentialRequestsPerHour
        maxAdminUsers
        maxUsers
      }
    }
    limitOverrides {
      mcpS3Connections
      mcpApiCatalogs
      mcpServers
      mcpUserRequestsPerHour
      mcpWorkspaceRequestsPerHour
      mcpApiCredentialRequestsPerHour
      maxAdminUsers
      maxUsers
    }
    billingContact {
      name
      email
      preferredContactMethod
      phone {
        internationalPrefix
        number
      }
    }
    operationalContact {
      name
      email
      preferredContactMethod
      phone {
        internationalPrefix
        number
      }
    }
  }
}
    `);
export const OrgDetailsDocument = new TypedDocumentString(`
    query OrgDetails($asRole: String) {
  getOrganization(asRole: $asRole) {
    orgId
    name
    logo
    domains
    onboardingStatus
    defaultRole {
      roleId
      name
      capabilities {
        action
        resources
        conditions
      }
    }
    subscription {
      product
      tier
      status
      expiry
    }
    billingContact {
      name
      email
      preferredContactMethod
      phone {
        internationalPrefix
        number
      }
    }
    operationalContact {
      name
      email
      preferredContactMethod
      phone {
        internationalPrefix
        number
      }
    }
    pendingInvites {
      userId
      expiration
    }
    roles {
      roleId
      name
      capabilities {
        action
        resources
        conditions
      }
      users {
        userId
        active
      }
      deactivated
    }
    members {
      active
      userId
      email
      firstName
      lastName
      orgId
      roles {
        roleId
        name
        isDefault
        capabilities {
          action
          resources
          conditions
        }
      }
      subscriptions {
        product
        tier
        status
        expiry
      }
    }
    apiCredentials {
      apiCredentialsId
      orgId
      expiresAt
      name
      role {
        name
        roleId
        capabilities {
          action
          resources
          conditions
        }
      }
      createdAt
      createdBy
      deactivated
    }
    unis {
      name
      alias
      orgId
      sku
      status
      initState
      created
      error
      owner
      ownerInfo {
        userId
        email
      }
      nodes {
        name
        orgId
        userId
        description
        status
        csp
        region
        vendiaAccount {
          csp
          accountId
          org
        }
        settings {
          apiSettings {
            auth {
              authorizerType
              allowList
            }
          }
        }
      }
    }
  }
}
    `);
export const OrgUsersDocument = new TypedDocumentString(`
    query OrgUsers($asRole: String) {
  listOrganizationUsers(asRole: $asRole) {
    active
    userId
    email
    firstName
    lastName
    orgId
    roles {
      name
      isDefault
      capabilities {
        action
        resources
        conditions
      }
    }
    subscriptions {
      product
      tier
      status
      expiry
    }
  }
}
    `);
export const UpdateOrgProfileDocument = new TypedDocumentString(`
    mutation UpdateOrgProfile($name: String, $asRole: String) {
  updateOrgProfile(name: $name, asRole: $asRole) {
    name
  }
}
    `);
export const DeleteUserRoleDocument = new TypedDocumentString(`
    mutation DeleteUserRole($userId: String, $roleName: String!, $asRole: String) {
  deleteUserRole(userId: $userId, roleName: $roleName, asRole: $asRole)
}
    `);
export const CreateOrgLogoUploadUrlDocument = new TypedDocumentString(`
    mutation CreateOrgLogoUploadUrl($fileName: String!, $asRole: String) {
  createOrgLogoUploadUrl(fileName: $fileName, asRole: $asRole)
}
    `);
export const DeleteOrgLogoDocument = new TypedDocumentString(`
    mutation DeleteOrgLogo($asRole: String) {
  deleteOrgLogo(asRole: $asRole)
}
    `);
export const SetOrgDefaultRoleDocument = new TypedDocumentString(`
    mutation SetOrgDefaultRole($roleId: String!, $asRole: String) {
  setOrgDefaultRole(roleId: $roleId, asRole: $asRole)
}
    `);
export const InviteToOrgDocument = new TypedDocumentString(`
    mutation InviteToOrg($userId: String!, $capabilities: [CapabilitiesInput!], $asRole: String) {
  inviteToOrg(userId: $userId, capabilities: $capabilities, asRole: $asRole) {
    expiration
  }
}
    `);
export const GetRoleDocument = new TypedDocumentString(`
    query GetRole($roleId: String!, $asRole: String) {
  getRole(roleId: $roleId, asRole: $asRole) {
    __typename
    ... on Role {
      roleId
      name
      orgId
      isDefault
      capabilities {
        action
        resources
        conditions
      }
      users {
        userId
      }
    }
  }
}
    `);
export const GetRoleFullUsersDocument = new TypedDocumentString(`
    query GetRoleFullUsers($roleId: String!, $asRole: String) {
  getRole(roleId: $roleId, asRole: $asRole) {
    roleId
    name
    orgId
    isDefault
    capabilities {
      action
      resources
      conditions
    }
    users {
      userId
      email
      firstName
      lastName
      orgId
    }
  }
}
    `);
export const CreateRoleDocument = new TypedDocumentString(`
    mutation CreateRole($name: String!, $capabilities: [CapabilitiesInput!]!, $asRole: String) {
  createRole(role: {name: $name, capabilities: $capabilities}, asRole: $asRole)
}
    `);
export const UpdateRoleDocument = new TypedDocumentString(`
    mutation UpdateRole($roleId: String!, $name: String!, $capabilities: [CapabilitiesInput!]!, $asRole: String) {
  updateRole(
    roleId: $roleId
    role: {name: $name, capabilities: $capabilities}
    asRole: $asRole
  )
}
    `);
export const DeactivateRoleDocument = new TypedDocumentString(`
    mutation DeactivateRole($roleId: String!, $asRole: String) {
  deactivateRole(roleId: $roleId, asRole: $asRole)
}
    `);
export const AssignRoleToUserDocument = new TypedDocumentString(`
    mutation AssignRoleToUser($roleId: String!, $userId: String!, $isDefault: Boolean!, $asRole: String) {
  assignRoleToUser(
    roleId: $roleId
    userId: $userId
    isDefault: $isDefault
    asRole: $asRole
  )
}
    `);
export const UnassignRoleFromUserDocument = new TypedDocumentString(`
    mutation UnassignRoleFromUser($roleId: String!, $userId: String!, $asRole: String) {
  unassignRoleFromUser(roleId: $roleId, userId: $userId, asRole: $asRole)
}
    `);
export const DeleteStorageConnectionV2Document = new TypedDocumentString(`
    mutation DeleteStorageConnectionV2($uniName: String!, $nodeName: String!, $storageConnectionId: String!, $asRole: String) {
  deleteStorageConnectionV2(
    uniName: $uniName
    nodeName: $nodeName
    storageConnectionId: $storageConnectionId
    asRole: $asRole
  ) {
    storageConnectionId
  }
}
    `);
export const GetStorageConnectionV2Document = new TypedDocumentString(`
    query GetStorageConnectionV2($uniName: String!, $nodeName: String!, $storageConnectionId: String!, $asRole: String) {
  getStorageConnectionV2(
    uniName: $uniName
    nodeName: $nodeName
    storageConnectionId: $storageConnectionId
    asRole: $asRole
  ) {
    id
    name
    type
    s3Config {
      bucket
      bucketRegion
      roleArn
    }
    defaultCapabilities
  }
}
    `);
export const ListStorageConnectionsV2Document = new TypedDocumentString(`
    query ListStorageConnectionsV2($uniName: String!, $nodeName: String!, $asRole: String) {
  listStorageConnectionsV2(
    uniName: $uniName
    nodeName: $nodeName
    asRole: $asRole
  ) {
    storageConnections {
      id
      name
      type
      s3Config {
        bucket
        bucketRegion
        roleArn
      }
      defaultCapabilities
    }
  }
}
    `);
export const AddStorageConnectionV2Document = new TypedDocumentString(`
    mutation AddStorageConnectionV2($uniName: String!, $nodeName: String!, $defaultCapabilities: [JSONObject], $connection: StorageConnectionV2Input!, $asRole: String) {
  addStorageConnectionV2(
    uniName: $uniName
    nodeName: $nodeName
    defaultCapabilities: $defaultCapabilities
    connection: $connection
    asRole: $asRole
  ) {
    storageConnectionId
  }
}
    `);
export const UpdateStorageConnectionV2Document = new TypedDocumentString(`
    mutation UpdateStorageConnectionV2($uniName: String!, $nodeName: String!, $defaultCapabilities: [JSONObject], $connection: StorageConnectionV2Input!, $asRole: String) {
  updateStorageConnectionV2(
    uniName: $uniName
    nodeName: $nodeName
    defaultCapabilities: $defaultCapabilities
    connection: $connection
    asRole: $asRole
  ) {
    storageConnectionId
  }
}
    `);
export const UniDocument = new TypedDocumentString(`
    query Uni($uniId: String!, $asRole: String) {
  getUni(uni: $uniId, asRole: $asRole) {
    name
    alias
    orgId
    sku
    status
    schema
    initState
    created
    error
    owner
    features
    nodes {
      name
      orgId
      userId
      description
      status
      csp
      region
      vendiaAccount {
        csp
        accountId
        org
      }
      settings {
        apiSettings {
          auth {
            authorizerType
            allowList
          }
        }
      }
      resources {
        graphqlApi {
          httpsUrl
          apiKey
          websocketUrl
        }
        smartContracts {
          aws_Role
        }
        mcpServer {
          url
        }
        cde {
          aws_Role
        }
        aws_FileStorage {
          arn
          name
        }
        aws_BlockNotifications {
          arn
        }
        aws_DeadLetterNotifications {
          arn
        }
        aws_Cognito {
          userPoolId
          userPoolClientId
          identityPoolId
        }
        azure_ApplicationId
        azure_BlockNotifications {
          id
          name
        }
        azure_DeadLetterNotifications {
          id
          name
        }
        azure_FileStorage {
          id
        }
        azure_SubscriptionId
        azure_TenantId
        dbConfig {
          username
          host
          port
          dbname
          engine
        }
      }
    }
  }
}
    `);
export const UniStatusDocument = new TypedDocumentString(`
    query UniStatus($uniId: String!, $asRole: String) {
  getUni(uni: $uniId, asRole: $asRole) {
    status
    nodes {
      name
      status
    }
  }
}
    `);
export const ListUnisDocument = new TypedDocumentString(`
    query ListUnis($limit: Int, $nextToken: String, $asRole: String) {
  listUnis(
    status: {not: [DESTROYING, DESTROYED]}
    limit: $limit
    nextToken: $nextToken
    asRole: $asRole
  ) {
    unis {
      name
      alias
      orgId
      sku
      status
      owner
      features
      created
      nodes {
        name
        orgId
        userId
        status
        settings {
          apiSettings {
            auth {
              allowList
            }
          }
        }
      }
    }
    nextToken
  }
}
    `);
export const NodeDocument = new TypedDocumentString(`
    query Node($uniId: String!, $nodeName: String!, $asRole: String) {
  getNode(uni: $uniId, node: $nodeName, asRole: $asRole) {
    name
    userId
    status
    resources {
      graphqlApi {
        httpsUrl
        websocketUrl
        apiKey
      }
      aws_FileStorage {
        arn
        name
      }
      aws_BlockNotifications {
        arn
      }
      aws_DeadLetterNotifications {
        arn
      }
      aws_Cognito {
        userPoolId
        userPoolClientId
        identityPoolId
      }
    }
  }
}
    `);
export const RegisterDocument = new TypedDocumentString(`
    mutation Register($name: String!, $alias: String, $sku: UniSkuEnum!, $schema: String!, $nodes: [NodeInput!]!, $initState: String, $privateFeatures: [String!], $asRole: String) {
  register(
    input: {name: $name, alias: $alias, sku: $sku, schema: $schema, nodes: $nodes, privateFeatures: $privateFeatures, initState: $initState}
    asRole: $asRole
  )
}
    `);
export const UpdateDocument = new TypedDocumentString(`
    mutation Update($uni: String!, $asRole: String) {
  update(uni: $uni, asRole: $asRole)
}
    `);
export const DeleteNodeDocument = new TypedDocumentString(`
    mutation DeleteNode($uni: String!, $node: String!) {
  leave(uni: $uni, node: $node, data: RETAIN, infrastructure: DESTROY) {
    message
  }
}
    `);
export const ArchiveNodeDocument = new TypedDocumentString(`
    mutation ArchiveNode($uni: String!, $node: String!) {
  leave(uni: $uni, node: $node, data: RETAIN, infrastructure: ARCHIVE) {
    message
  }
}
    `);
export const ResetDocument = new TypedDocumentString(`
    mutation Reset($uniId: String!, $asRole: String) {
  reset(uni: $uniId, asRole: $asRole)
}
    `);
export const DestroyDocument = new TypedDocumentString(`
    mutation Destroy($uniId: String!, $asRole: String) {
  destroy(uni: $uniId, asRole: $asRole)
}
    `);
export const EvolveSchemaDocument = new TypedDocumentString(`
    mutation EvolveSchema($uniId: String!, $schema: String!, $allowedBreakingChanges: [EvolveSchemaBreakingChangesEnum!], $asRole: String) {
  evolveSchema(
    uni: $uniId
    input: {schema: $schema, allowedBreakingChanges: $allowedBreakingChanges}
    asRole: $asRole
  ) {
    breakingChanges
    evolutionMode
  }
}
    `);
export const UpgradeAuthDocument = new TypedDocumentString(`
    mutation UpgradeAuth($uniName: String!) {
  upgradeAuth(uni: $uniName) {
    message
  }
}
    `);
export const InviteDocument = new TypedDocumentString(`
    mutation Invite($uni: String!, $userId: String!, $asRole: String) {
  invite(uni: $uni, userId: $userId, asRole: $asRole) {
    token
    expiration
  }
}
    `);
export const JoinDocument = new TypedDocumentString(`
    mutation Join($uni: String!, $token: String!, $nodeInput: NodeInput!, $asRole: String) {
  join(uni: $uni, token: $token, input: $nodeInput, asRole: $asRole)
}
    `);
export const UpdateUniSkuDocument = new TypedDocumentString(`
    mutation UpdateUniSku($uniName: String!, $sku: UniSkuEnum!, $asRole: String) {
  updateUniSku(uni: $uniName, sku: $sku, asRole: $asRole) {
    message
  }
}
    `);
export const UpdateUniAliasDocument = new TypedDocumentString(`
    mutation UpdateUniAlias($uniName: String!, $alias: String!, $asRole: String) {
  updateUniAlias(uni: $uniName, alias: $alias, asRole: $asRole) {
    message
  }
}
    `);
export const GrantNodeAccessDocument = new TypedDocumentString(`
    mutation GrantNodeAccess($uniName: String!, $nodeName: String!, $users: [String!]!, $accessLevel: NodeAccessLevel!) {
  grantNodeAccess(
    uni: $uniName
    node: $nodeName
    users: $users
    accessLevel: $accessLevel
  ) {
    message
  }
}
    `);
export const RevokeNodeAccessDocument = new TypedDocumentString(`
    mutation RevokeNodeAccess($uniName: String!, $nodeName: String!, $users: [String!]!) {
  revokeNodeAccess(uni: $uniName, node: $nodeName, users: $users) {
    message
  }
}
    `);
export const UserDocument = new TypedDocumentString(`
    query User($userId: String, $asRole: String) {
  getUser(userId: $userId, asRole: $asRole) {
    email
    firstName
    lastName
    userId
    orgId
    roles {
      name
      roleId
      orgId
      isDefault
      capabilities {
        action
        resources
        conditions
      }
    }
    subscriptions {
      product
      tier
      status
      expiry
    }
  }
}
    `);
export const DeactivateUserDocument = new TypedDocumentString(`
    mutation DeactivateUser($userEmail: String!, $asRole: String) {
  deactivateUser(userEmail: $userEmail, asRole: $asRole)
}
    `);
export const UpdateUserDocument = new TypedDocumentString(`
    mutation UpdateUser($userId: String!, $input: UserInput!, $asRole: String) {
  updateUser(userId: $userId, input: $input, asRole: $asRole)
}
    `);
export const LogoutUserDocument = new TypedDocumentString(`
    mutation LogoutUser {
  logoutUser
}
    `);
export const SetUserRoleDocument = new TypedDocumentString(`
    mutation SetUserRole($userId: String, $roleName: String!, $capabilities: [CapabilitiesInput!]!, $asRole: String) {
  setUserRole(
    userId: $userId
    roleName: $roleName
    capabilities: $capabilities
    asRole: $asRole
  )
}
    `);
export const GetWorkflowsTokenDocument = new TypedDocumentString(`
    query GetWorkflowsToken($input: WorkflowsTokenInput!) {
  getWorkflowsToken(input: $input) {
    token
  }
}
    `);
export const ListWorkflowRecipesDocument = new TypedDocumentString(`
    query ListWorkflowRecipes($uni: String!, $node: String!) {
  listWorkflowRecipes(uni: $uni, node: $node) {
    folderId
    recipes
  }
}
    `);
export const ListWorkflowConnectionsDocument = new TypedDocumentString(`
    query ListWorkflowConnections($uni: String!, $node: String!) {
  listWorkflowConnections(uni: $uni, node: $node) {
    folderId
    connections
  }
}
    `);
export const EnableWorkflowDocument = new TypedDocumentString(`
    mutation EnableWorkflow($input: EnableWorkflowsInput!, $asRole: String) {
  enableWorkflow(input: $input, asRole: $asRole) {
    message
  }
}
    `);
export const UpdateWorkflowResourcesDocument = new TypedDocumentString(`
    mutation UpdateWorkflowResources($input: UpdateWorkflowResourcesInput!, $asRole: String) {
  updateWorkflowResources(input: $input, asRole: $asRole) {
    message
  }
}
    `);
export const VerifyWorkflowDocument = new TypedDocumentString(`
    query VerifyWorkflow($input: EnableWorkflowsInput!, $asRole: String) {
  verifyWorkflow(input: $input, asRole: $asRole) {
    missingResources
  }
}
    `);
//# sourceMappingURL=graphql.js.map